import React, { useEffect, useState } from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';
import { getActiveUsers, ActiveUsersDay } from '../../services/adminApi';

export const ActiveUsersChart: React.FC = () => {
  const [data, setData] = useState<ActiveUsersDay[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    getActiveUsers()
      .then(setData)
      .catch(() => setError('Failed to load active users'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="admin-loading">Loading active users...</div>;
  if (error) return <div className="admin-error">{error}</div>;
  if (!data.length) return <div className="admin-empty">No activity data yet.</div>;

  return (
    <div className="admin-chart-container">
      <h3>DAU / WAU / MAU (90 days)</h3>
      <ResponsiveContainer width="100%" height={350}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" tick={{ fontSize: 11 }} interval={13} />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="dau" stroke="#3b82f6" name="DAU" dot={false} />
          <Line type="monotone" dataKey="wau" stroke="#8b5cf6" name="WAU" dot={false} />
          <Line type="monotone" dataKey="mau" stroke="#f59e0b" name="MAU" dot={false} />
        </LineChart>
      </ResponsiveContainer>

      <h3 style={{ marginTop: '2rem' }}>Stickiness (DAU/MAU %)</h3>
      <ResponsiveContainer width="100%" height={250}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" tick={{ fontSize: 11 }} interval={13} />
          <YAxis unit="%" />
          <Tooltip />
          <Line type="monotone" dataKey="stickiness" stroke="#22c55e" name="Stickiness %" dot={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
